import Vue from 'vue'
import Router from 'vue-router'

import {AppConfig} from '@/config/AppConfig';

const prefix = AppConfig.VUE_APP_DOMAIN_PREFIX;

const Index = () => import('@/components/Index.vue');


const IdentityVerification = () => import('@/components/common/IdentityVerification.vue');

const Gift = () => import('@/components/gift/Gift.vue');                                     // 선물하기
const GetGiftDetail = () => import('@/components/giftshop/giftbox/GetGiftDetail.vue');                   // 받은 선물 상세
const SendGiftDetail = () => import('@/components/giftshop/giftbox/SendGiftDetail.vue');                   // 받은 선물 상세
// 유저 세팅
const UserSettings = () => import('@/components/member/UserSettings.vue');                // 유저 세팅

// 알림
const NoticeList = () => import('@/components/notice/NoticeList.vue');                           //   알림

// 회원 가입 및 관련 항목
const Member = () => import('@/components/member/Member.vue');                            // 회원 가입 페이지
const MemberPrivacy = () => import('@/components/member/Privacy.vue');                    // 약관 동의 페이지
const MemberInfo = () => import('@/components/member/Info.vue');                          // 회원 정보 입력 페이지
const MemberCommit = () => import('@/components/member/Commit.vue');                      // 회원 가입 완료
const TermsMembers = () => import('@/components/member/TermsMembers.vue');                // 회원 이용 약관
const TermsPrivacy = () => import('@/components/member/TermsPrivacy.vue');                // 개인 정보방침 약관
const TermsLocation = () => import('@/components/member/TermsLocation.vue');              // 회원 이용 약관
const Benefit = () => import('@/components/member/Benefit.vue');                          // 회원 혜택
const BenefitLevel = () => import('@/components/member/BenefitLevel.vue');                // 회원 등급
const CashReceipts = () => import('@/components/member/CashReceipts.vue');              // 현금 영수증 발급 정보


// 로그인 및 관련 항목, 로그 아웃
const Login = () => import('@/components/member/Login.vue');                              // 로그인 메인 페이지
const LogCS = () => import('@/components/member/LogCS.vue');                              // 휴면 회원 복구 페이지
const RestoreUser = () => import('@/components/member/RestoreUser.vue');                  // 계정 전환 복구 페이지'
const NaverLoginCallback = () => import('@/components/member/NaverLoginCallback.vue');    //Naver Login Callback
const AppleLoginCallback = () => import('@/components/member/AppleLoginCallback.vue');    //Apple Login Callback

const FindId = () => import('@/components/member/FindId.vue');                            // 아이디 찾기
const FindIdSave = () => import('@/components/member/FindIdSave.vue');                  // 아이디 입력
const FindIdSuccess = () => import('@/components/member/FindIdSuccess.vue');              // 아이디 찾기 성공
const FindIdFail = () => import('@/components/member/FindIdFail.vue');                    // 아이디 찾기 실패
const FindPassword = () => import('@/components/member/FindPassword.vue');                // 패스워드 찾기
const ChangePassword = () => import('@/components/member/ChangePassword.vue');            // 패스워드 변경
const ResetPassword = () => import('@/components/member/ResetPassword.vue');            // 패스워드 재설정
const ChangeNickname = () => import('@/components/member/ChangeNickname.vue');            // 닉네임 변경
const ChangeUserInfor = () => import('@/components/member/ChangeUserInfor.vue');          // 닉네임 변경

//Order
const Cart = () => import('@/components/order/cart/Cart.vue');                                     // 장바구니


const OrderMain = () => import('@/components/order/OrderMain.vue');                                 // Order
const OrderStoreList = () => import('@/components/order/store/OrderStoreList.vue');                         // 매장주문
const OrderDelivery = () => import('@/components/order/delivery/OrderDelivery.vue');                // 배달주문



const StoreMain = () => import('@/components/order/store/StoreMain.vue');                  // 매장주문
const StoreMenu = () => import('@/components/order/store/StoreMenu.vue');                  // 매장주문
const StoreMyMenu = () => import('@/components/order/store/MyMenu.vue');                              //나의 메뉴
const StoreOrderHistory = () => import('@/components/order/store/OrderHistoryMain.vue')    //주문내역
const StoreOrderHistoryDetail = () => import('@/components/order/store/OrderHistoryDetail.vue')    //주문내역 상세

const StoreQuickOrder = () => import('@/components/order/store/QuickOrder.vue');       //퀵오더

const StoreMenuInfo = () => import('@/components/order/store/StoreMenuInfo.vue');          //메뉴 상세
const StoreMenuOptionDialog = () => import('@/components/order/store/StoreMenuOptionDialog.vue');          //메뉴 상세 - 옵션


// OrderHistoryInfo
const OrderHistoryInfo = () => import('@/components/order/store/OrderHistoryInfo.vue');          //주문/선물 상세



const DeliveryStoreList = () => import('@/components/order/delivery/DeliveryStoreList.vue');          //배달 매장선택
const OrderPayPrepaid = () => import('@/components/order/pay/PayPrepaid.vue');                       //결제하기


const OrderPayPrepaidCommitSuccess = () => import('@/components/order/pay/OrderPayPrepaidCommitSuccess.vue');       //MyTea 오더 - 결제하기 성공
const DeliveryPayPrepaidCommitSuccess = () => import('@/components/order/pay/DeliveryPayPrepaidCommitSuccess.vue');             //딜리버리오더 - 결제하기 성공
const CancelPayPrepaidCommitSuccess = () => import('@/components/order/pay/CancelPayPrepaidCommitSucces.vue');             //주문취소 - 성공


// GiftShop
// const GiftShopMain = () => import("@/components/giftshop/GiftShopMain.vue");                      // GiftShop Main

const GiftShop = () => import("@/components/giftshop/GiftShop.vue");                      // GiftShop Main
const GiftBoxRegist = () => import("@/components/giftshop/giftbox/GiftBoxRegist.vue");            // 선물 등록
const RejectGift = () => import("@/components/giftshop/RejectGift.vue");                  // 선물 거절
const EGiftDetail = () => import("@/components/giftshop/egift/GiftDetail.vue");                  // 선물하기(egift)

import GiftCardDetail from "../components/giftshop/gongchaCard/CardDetail.vue";
const GiftShopCart = () => import("@/components/giftshop/Cart.vue");              // 기프트샵 카트
const GiftRefund = () => import('@/components/giftshop/giftbox/GiftRefundMain.vue');            // 선물 환불요청

const GiftCompleted = () => import('@/components/gift/GiftCompleted.vue');            // 선물 완료

// Stamp
const StampMain = () => import("@/components/stamp/StampMain.vue");
const SaveDetail = () => import("@/components/stamp/SaveDetail.vue");                     // Stamp 적립내역
const StampFrequency = () => import("@/components/stamp/StampFrequency.vue");                     // Stamp 적립내역


// Shop
const FindShopMain = () => import("@/components/shop/FindShopMain.vue");                      // 매장 찾기

// const ShopSearch = () => import("@/components/shop/ShopSearch.vue");                            // 매장 찾기
// const ShopNear = () => import("@/components/shop/ShopNear.vue");                          // 가까운 매장
// const ShopMy = () => import("@/components/shop/ShopMy.vue");                              // 가까운 매장
const ShopDetail = () => import("@/components/shop/ShopDetail.vue");                          // 매장 검색 결과 화면
const FindShopOrder = () => import("@/components/shop/FindShopOrder.vue");                // 매장 검색 결과 화면


// EventNews
const EventNewsMain = () => import("@/components/eventnews/EventNewsMain.vue");                   // EventNews Event
// const EventList = () => import("@/components/eventnews/EventList.vue");                   // EventNews Event
const EventView = () => import("@/components/eventnews/EventView.vue");                   // EventNews Event 상세 보기
// const NewsList = () => import("@/components/eventnews/NewsList.vue");                     // EventNews News
const NewsView = () => import("@/components/eventnews/NewsView.vue");                     // EventNews News 상세 보기

// 고객센터
const Customer = () => import('@/components/member/Customer.vue');
const Faq = () => import('@/components/member/Faq.vue');
const ContactUs = () => import('@/components/member/ContactUs.vue');
const ContactUsComplete = () => import('@/components/member/ContactUsComplete.vue');

// 이용안내
const Guide = () => import('@/components/member/Guide.vue');
const HowToOrder = () => import('@/components/member/HowToOrder.vue');

// Coupon
const CouponMain = () => import('@/components/coupon/CouponMain.vue');
const RegistCoupon = () => import('@/components/coupon/RegistCoupon.vue');



const RegistCouponDone = () => import('@/components/coupon/RegistCouponDone.vue');

const CouponUsableDetail = () => import('@/components/coupon/CouponUsableDetail.vue');
const GiftCoupon = () => import('@/components/coupon/GiftCoupon.vue');
const GiftCouponDone = () => import('@/components/coupon/GiftCouponDone.vue');

const GiftCouponDetail = () => import('@/components/coupon/GiftCouponDetail.vue');



// 카드
const CardList = () => import('@/components/card/CardList.vue');

import CardDetail from "../components/card/CardDetail.vue";
const CardCharge = () => import('@/components/card/CardCharge.vue');
const CardChargeComplete = () => import('@/components/card/CardChargeComplete.vue');
const CardChargeCancel = () => import('@/components/card/CardChargeCancel.vue');
const CardChargeCancelComplete = () => import('@/components/card/CardChargeCancelComplete.vue');
const RegistCard = () => import('@/components/card/RegistCard.vue');
const CardHistory = () => import('@/components/card/CardHistory.vue');
const CardHistoryUseDetail = () => import('@/components/card/CardHistoryUseDetail.vue');
const CardHistoryChargeDetail = () => import('@/components/card/CardHistoryChargeDetail.vue');
const CardLostReport = () => import('@/components/card/CardLostReport.vue');
const CardLostReportComplete = () => import('@/components/card/CardLostReportComplete.vue');

const SlickTest = () => import('@/components/index/SlickTest.vue');
const EzPayView = () => import('@/components/payment/EzPayView.vue');                         // 결제 요청페이지

//설문조사
import SurveyMain from "../components/survey/SurveyMain.vue";
import Survey from "../components/survey/Survey.vue";
import SurveyQuestionList from "../components/survey/SurveyQuestionList.vue";
import SurveyComplete from "../components/survey/SurveyComplete.vue";


import SurveyGuest from "../components/survey/SurveyGuest.vue";
import SurveyGuestQuestionList from "../components/survey/SurveyGuestQuestionList.vue";
import SurveyGuestComplete from "../components/survey/SurveyGuestComplete.vue";
import SelectMobileGiftDialog from "../components/order/SelectMobileGiftDialog.vue";
import SelectMobileGiftAddDialog from "../components/order/SelectMobileGiftAddDialog.vue";

import EventRedirect from "../components/common/EventRedirect.vue";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    { path: prefix+'/slicktest',                                   component: SlickTest},

    { path: prefix+'/',                                             component: Index },
    // { path:'/home', name:'home', component: Home ,props:{is_login : true}},
    { path: prefix+'/index',                                        component: Index },
    { path: prefix+'/gift',                                        component: Gift ,name:'gift' ,props: true},

    { path: prefix+'/ezpay',                                       component: EzPayView ,name:'ezpayview' ,props: true},

    { path: prefix+'/refund',                                        component: GiftRefund, name: "refund", props: true },

    // 유저 세팅
    { path: prefix+'/settings',                                     component: UserSettings },
    { path: prefix+'/notice',                                       component: NoticeList },

    // 회원 가입
    { path: prefix+'/member',                                      component: Member},
    { path: prefix+'/member/privacy',                              component: MemberPrivacy,props: true ,name:"member_privacy"},
    { path: prefix+'/member/info',                                 component: MemberInfo},
    { path: prefix+'/member/commit',                               component: MemberCommit},
    { path: prefix+'/member/termsmembers',                         component: TermsMembers},
    { path: prefix+'/member/termsprivacy',                         component: TermsPrivacy},
    { path: prefix+'/member/termslocation',                        component: TermsLocation},
    { path: prefix+'/member/benefit',                              component: Benefit},
    { path: prefix+'/member/level',                                component: BenefitLevel},
    { path: prefix+'/member/cash',                                 component: CashReceipts},

    // 로그인 관련
    { path: prefix+'/login',                                       component: Login ,props: true, name: "login"},
    { path: prefix+'/login/dormant',                                       component: LogCS},

    { path: prefix+'/login/verification',                                       component: IdentityVerification},

    { path: prefix+'/login/restoreUser',                                       component: RestoreUser,props: true, name: "restore_user"},

    // NaverLoginCallback
    { path: prefix+'/login/naver_login_callback',                        component: NaverLoginCallback},

    { path: prefix+'/login/apple_login_callback',                        component: AppleLoginCallback},

    { path: prefix+'/login/id',                                    component: FindId},
    { path: prefix+'/login/id/save',                              component: FindIdSave, props: true, name: "find_id_save"},
    { path: prefix+'/login/id/success',                            component: FindIdSuccess, props: true, name: "find_id_success"},
    { path: prefix+'/login/id/fail',                               component: FindIdFail},
    { path: prefix+'/login/password',                              component: FindPassword, props: true, name: "find_pw"},
    { path: prefix+'/login/changepw',                              component: ChangePassword, props: true, name: "change_pw"},
    { path: prefix+'/login/resetpw',                              component: ResetPassword, props: true, name: "reset_pw"},
    { path: prefix+'/login/changename',                            component: ChangeNickname},
    { path: prefix+'/login/changeinfor',                           component: ChangeUserInfor},


    { path: prefix+'/order',                                       component: OrderMain},
    { path: prefix+'/order/cart',                                  component: Cart},
    { path: prefix+'/order/store/:storeCode/cart',                 component: Cart ,props : true , name:'store_cart'},

    { path: prefix+'/order/delivery',                              component: OrderDelivery},
    { path: prefix+'/order/store',                                 component: OrderStoreList},
    { path: prefix+'/order/delivery/store',                        component: DeliveryStoreList},

    { path: prefix+'/order/store/:storeCode',                      component: StoreMain ,props: true ,name:'store_main'},
    { path: prefix+'/order/store/:storeCode/menu',                 component: StoreMenu ,props: true ,name:'store_menu'},
    { path: prefix+'/order/store/:storeCode/mymenu',               component: StoreMyMenu,props: true ,name:'store_mymenu'},
    { path: prefix+'/order/store/:storeCode/menu/:menuId',         component: StoreMenuInfo ,props: true ,name:'store_menu_info'},
    { path: prefix+'/order/store/:storeCode/menu/:menuId/options',         component: StoreMenuOptionDialog ,props: true ,name:'store_menu_info_options'},

    { path: prefix+'/order/store/:storeCode/history',              component: StoreOrderHistory,props: true ,name:'store_history'},

    { path: prefix+'/order/store/:storeCode/history/:orderNo',     component: StoreOrderHistoryDetail ,props: true ,name:'order_store_history_detail',},
    { path: prefix+'/order/store/:storeCode/history/:orderNo/:isModal', component: StoreOrderHistoryDetail ,props: true ,name:'order_store_history_detail_modal'},

    { path: prefix+'/order/store/:storeCode/quickorder',           component: StoreQuickOrder,props: true ,name:'store_quick_order'},

    { path: prefix+'/order/history/:orderNo',     component: StoreOrderHistoryDetail ,props: true ,name:'order_history_detail',},

    // 메인 주문내역
    { path: prefix+'/order/history',              component: StoreOrderHistory,props: true ,name:'order_history'},



    { path: prefix+'/order/payprepaid',                            component: OrderPayPrepaid  ,props: true,name:'order_payprepaid',},
    { path: prefix+'/order/payprepaid/pay',                        component: EzPayView  ,props: true,name:'order_payprepaid_pay',},

    { path: prefix+'/order/payprepaid/orderCompleted',             component: OrderPayPrepaidCommitSuccess},
    { path: prefix+'/order/payprepaid/deliveryCompleted',          component: DeliveryPayPrepaidCommitSuccess},
    { path: prefix+'/order/payprepaid/cancelCompleted',            component: CancelPayPrepaidCommitSuccess},



    // GiftShop
    // { path: prefix+'/giftshop',                          component: GiftShopMain},
    { path: prefix+'/giftshop',                                    component: GiftShop},
    { path: prefix+'/giftshop/main/:tab',                               component: GiftShop , props:true, name:'giftshop_main_tab'},
    { path: prefix+'/giftshop/giftbox/regist',                     component: GiftBoxRegist},
    { path: prefix+'/giftshop/reject',                             component: RejectGift},
    { path: prefix+'/giftshop/egift/detail',                       component: EGiftDetail,         props: true,      name: 'giftshop_egift_detail'},
    { path: prefix+'/giftshop/gongcha/detail',                     component: GiftCardDetail,         props: true,      name: 'giftshop_gongchacard_detail'},
    { path: prefix+'/giftshop/gift',                               component: Gift ,name:'giftshop_gift' ,props: true},
    { path: prefix+'/giftshop/gift/get/detail',                    component: GetGiftDetail ,name:'giftshop_gift_get_detail' ,props: true},
    { path: prefix+'/giftshop/gift/send/detail',                    component: SendGiftDetail ,name:'giftshop_gift_send_detail' ,props: true},

    { path: prefix+'/giftshop/gift/completed',                               component: GiftCompleted},


    { path: prefix+'/giftshop/cart',                               component: GiftShopCart ,name:'giftshop_cart'},

    { path: prefix+'/giftshop/gift/:presentNo/refund',                        component: GiftRefund ,name:'giftshop_refund', props: true },

    { path: prefix+'/giftshop/egift/detail/:productCode',                       component: EGiftDetail,         props: true,      name: 'giftshop_egift_detail'},
    { path: prefix+'/giftshop/card/detail/:productCode',                       component: GiftCardDetail,         props: true,      name: 'giftshop_card_detail'},
    { path: prefix+'/giftshop/egift/regist/:presentNo',                     component: GiftBoxRegist, props:true, name:'giftshop_egift_regist'},

    // Stamp
    { path: prefix+'/stamp',                                       component: StampMain, name: 'stamp_main', props: true },
    { path: prefix+'/stamp/saveDetail',                            component: SaveDetail},
    { path: prefix+'/stamp/frequency',                            component: StampFrequency, name: 'stamp_frequency', props: true},
    { path: prefix+'/stamp/frequency/:frequencyNo',               component: StampFrequency, name: 'stamp_frequency_detail', props: true},


    // Shop

    { path: prefix+'/findShopMain',                                component: FindShopMain},
    { path: prefix+'/findShopDetail',                              component: ShopDetail ,props: true, name:'findshop_detail'},
    { path: prefix+'/findShopOrder',                               component: FindShopOrder},


    // EventNews
    { path: prefix+'/eventnews',                                   component: EventNewsMain},
    { path: prefix+'/eventnews/event/:eventNo',                          component: EventView, props: true, name: "EventView"},
    { path: prefix+'/eventnews/news/:newsNo',                           component: NewsView, props: true, name: "NewsView"},

    // 고객센터
    { path: prefix+'/customer',                                     component: Customer },
    { path: prefix+'/contactus',                                    component: ContactUs },
    { path: prefix+'/contactus/complete',                           component: ContactUsComplete },
    { path: prefix+'/faq',                                          component: Faq },


    // 이용안내
    { path: prefix+'/guide',                                        component: Guide },
    { path: prefix+'/howtoorder',                                   component: HowToOrder },

    // Coupon
    { path: prefix+'/coupon',                                       component: CouponMain ,name:'coupon_main',props:true},
    { path: prefix+'/coupon/regist',                                component: RegistCoupon},
    { path: prefix+'/coupon/regist/:couponNo',                                component: RegistCoupon,name:'coupon_regist',props:true},
    { path: prefix+'/coupon/regist/done',                           component: RegistCouponDone,name:'coupon_regist_done',props:true},
    { path: prefix+'/coupon/detail/:couponNo/use',                  component: CouponUsableDetail ,name:'coupon_detail_use',props:true},
    { path: prefix+'/coupon/detail/:couponNo/use/gift',             component: GiftCoupon,name:'coupon_detail_use_gift',props:true },
    { path: prefix+'/coupon/detail/:couponNo/use/gift/done',        component: GiftCouponDone,name:'coupon_detail_use_gift_done',props:true },
    { path: prefix+'/coupon/detail/:couponNo/gift',                 component: GiftCouponDetail,name:'coupon_detail_gift',props:true },


    // Card
    { path: prefix+'/card',                                         component: CardList },
    { path: prefix+'/card/regist',                                  component: RegistCard },
    { path: prefix+'/card/:cardNo',                                 component: CardDetail ,name:'card_info',props:true},
    { path: prefix+'/card/:cardNo/charge',                          component: CardCharge ,name:'card_charge',props:true},
    { path: prefix+'/card/:cardNo/charge/complete',                 component: CardChargeComplete ,name:'card_charge_complete',props:true},
    { path: prefix+'/card/:cardNo/charge/:orderNo/cancel',          component: CardChargeCancel ,name:'card_charge_cancel',props:true},
    { path: prefix+'/card/:cardNo/charge/:orderNo/cancel/complete', component: CardChargeCancelComplete ,name:'card_charge_cancel_complete',props:true},
    { path: prefix+'/card/:cardNo/history',                         component: CardHistory ,name:'card_history',props:true},
    { path: prefix+'/card/:cardNo/history/:orderNo/use',            component: CardHistoryUseDetail ,name:'card_history_use',props:true},
    { path: prefix+'/card/:cardNo/history/:orderNo/charge',         component: CardHistoryChargeDetail ,name:'card_history_charge',props:true},
    { path: prefix+'/card/:cardNo/lostReport',                      component: CardLostReport ,name:'card_lost_report',props:true},
    { path: prefix+'/card/:cardNo/lostReport/complete',             component: CardLostReportComplete ,name:'card_lost_report_complete',props:true},

    { path: prefix+'/card/regist/:cardNo',                                  component: RegistCard ,name:'card_regist',props:true},
    { path: prefix+'/card/regist/:cardNo/:pinNo',                                  component: RegistCard ,name:'card_regist',props:true},
    // { path: '*', component: NotFoundComponent },
    {
      path: '/survey',
      component: SurveyMain
    },
    {
      path: '/survey/complete',
      component: SurveyComplete
    },
    {
      path: '/survey/:surveyId',
      component: Survey
    },
    {
      path: '/survey/:surveyId/questions',
      component: SurveyQuestionList
    },
    {
      path:'/surveyGuest/:orderNo',
      component: SurveyGuest
    },
    {
      path: '/surveyGuest/:surveyId/questions/:orderNo/:surveyMemberId/',
      component: SurveyGuestQuestionList
    },
    {
      path: '/surveyGuest/complete/:orderNo',
      component: SurveyGuestComplete
    },
    {
      path: '/order/mobileGift',
      name: 'selectmobilegiftdialog',
      props : true,
      component: SelectMobileGiftDialog
    },
    {
      path: '/order/mobileGift/add',
      component: SelectMobileGiftAddDialog
    },
    {
      path: '/event/:eventId',
      component: EventRedirect
    },
    {
      path: '/event',
      component: EventRedirect,
        props: (route) => ({
            link : route.query.link
        })
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
})





// WEBPACK FOOTER //
// ./src/router/index.js